import { render, staticRenderFns } from "./VersionField.vue?vue&type=template&id=08c940aa&scoped=true&"
import script from "./VersionField.vue?vue&type=script&lang=js&"
export * from "./VersionField.vue?vue&type=script&lang=js&"
import style0 from "./VersionField.vue?vue&type=style&index=0&id=08c940aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c940aa",
  null
  
)

export default component.exports